import React from "react";
import Text from "theme/Text";
import { NoResultsViewStyles } from 'styles/components/atoms/NoResultsView'
import { colorList } from 'utils/colors'
import { ThemedShared } from 'styles/themed'
import IconBackground, { IconBackgroundSizes } from 'components/atoms/IconBackground'
import ThemedBlock from 'components/atoms/ThemedBlock'
import isEqual from 'react-fast-compare'


const NoResultsView = ({ testID = null, children }) => {
	
	const textStyle = [
		NoResultsViewStyles.text,
		ThemedShared.paddingMedium
	]
	
	return (
		<ThemedBlock
			key={'no_results_container_text'}
			shadow
			testID={ testID }>
			
			<IconBackground
				colourfull
				iconSize={ IconBackgroundSizes.S }
				linearGradientColours={ [ colorList.WHITE.primary, colorList.WHITE.dark ] }
				containerStyle={ ThemedShared.borderRadius }
				opacity={ 0.6 }>
				
				<Text
					key={'no_results_container_text_text'}
					category={ "s1" }
					style={ textStyle }>
					
					{ children }
				</Text>
			</IconBackground>
		</ThemedBlock>
	)
 }


export default React.memo( NoResultsView, isEqual );
